import React, { Component } from 'react';
import './../assets/css/App.css';
import './../assets/css/styles.min.css';
import { getLinkedTable } from './helper.js';

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chosenCountry: '',
      chosenCountryID: null,
      chosenSubject: '',
      chosenSubjectID: '',
      isDisabled: false
    };

    this.handleSelectedCountry = this.handleSelectedCountry.bind(this);
    this.handleSelectedSubject = this.handleSelectedSubject.bind(this);
    this.updateSubjectArr = this.updateSubjectArr.bind(this);
  }

  handleSelectedCountry(event) {
    const selectedCountryID = event.target.value;

    let subjectarray = this.props.subjectData;
    if (event.target.value === 'any') {
      // No chosen country populate dropdown

      this.updateSubjectArr(subjectarray, 'ajax', selectedCountryID);
    } else {
      this.setState({
        chosenCountryID: event.target.value
      });

      // Filter out chosen country object
      subjectarray = this.props.countryData
        .filter(item => {
          // use .includes instead?
          return item.id === event.target.value;
        })
        // selected first returned array

        .map(subject => {
          return subject.fields['subject'];
        })[0];

      this.updateSubjectArr(subjectarray, 'change', event.target.value);
    }
  }

  handleSelectedSubject(event) {
    console.log(event.target);
  }

  handleshowResults(event) {
    getLinkedTable('partner_universities');
  }
  updateSubjectArr(subjects, method, event) {
    this.props.updateSubjectArr(subjects, method, event);
  }

  render() {
    const subjectArr = this.props.subjectList;

    let subjectDropdownHTML = subjectArr.map((subject, index) => {
      return (
        <option key={index} value={subject} id={index}>
          {subject}
        </option>
      );
    });

    return (
      <div className="form-container">
        <div className="panel-body">
          <form>
            <label htmlFor="countryID">I want to go to</label>
            <select
              ref="userInput"
              defaultValue="any country"
              id="countryID"
              onChange={this.handleSelectedCountry}
              disabled={this.props.isDisabled}
            >
              <option value="any" defaultValue>
                any country
              </option>
              {this.props.countryData.map(country => {
                return (
                  <option key={country.id} id={country.id} value={country.id}>
                    {country.fields['country']}
                  </option>
                );
              })}
            </select>
            <span>or</span>
            <p>
              <label htmlFor="subjectID">study</label>

              <select ref="userInput" id="subjectID" onChange={this.handleSelectedSubject}>
                <option value="any" defaultValue>
                  any subject
                </option>
                {subjectDropdownHTML}
              </select>
            </p>
            <p>
              <button className="btn bg-d-blue" onClick={this.props.onChange}>
                Show me the options
              </button>
            </p>
          </form>
        </div>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/form.js